import { defineComponent as _defineComponent } from 'vue'
import GlobalCard from '@/features/global-home/components/card/GlobalCard.vue';

import { TrackingHelper } from '@/helpers/tracking/tracking-helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalCards',
  setup(__props) {

const imageOnePlace = `/${ASSETS_DIR}/img/home/all_in_one_place-comp.png`;
const imageOneSearch = `/${ASSETS_DIR}/img/home/one_search-comp-2.png`;
const imageOneList = `/${ASSETS_DIR}/img/home/one_watchlist-comp.png`;

function handleSearchBarFocus() {
	const searchInput = document.getElementById('searchbar-input') as HTMLInputElement;
	searchInput?.focus();

	TrackingHelper.trackEvent('userinteraction', {
		action: 'open_suggester',
		label: 'GLOBAL_ONE_SEARCH',
	});
}

function trackClick(label: string, property: string) {
	TrackingHelper.trackEvent('userinteraction', {
		action: 'tabchange',
		label,
		useLastRoute: true,
		property,
	});
}

return { __sfc: true,imageOnePlace, imageOneSearch, imageOneList, handleSearchBarFocus, trackClick, GlobalCard }
}

})